import styled from 'styled-components';
import { CaptionText, FlexRow, SvgIcon } from '@make-software/cspr-design';
import { BodyText, Button } from '@block-explorer/ui';
import React from 'react';

export enum DexType {
  CSPR_TRADE,
  CSPR_FUN,
  FRIENDLY_MARKET,
}

const StyledButton = styled(Button)(({ theme }) => ({
  height: '24px',
  minHeight: '24px',
  padding: '2px 8px',
  borderRadius: theme.borderRadius.base,
}));

const DexIcons = {
  [DexType.CSPR_TRADE]: 'assets/icons/ic-cspr-trade-dex.svg',
};

interface DexButtonProps {
  label: string | React.ReactNode;
  type?: DexType;
  iconPath?: string | null;
  onClick?: () => void;
}

export const DexButton = ({
  type,
  iconPath,
  label,
  onClick,
}: DexButtonProps) => {
  const iconPathUrl = iconPath || DexIcons[type];

  const buttonLabel =
    typeof label === 'string' ? (
      <CaptionText size={1}>{label}</CaptionText>
    ) : (
      label
    );

  return (
    <StyledButton color={'secondaryBlue'} onClick={onClick}>
      <FlexRow gap={6} align={'center'}>
        <SvgIcon src={iconPathUrl} alt={'Dex Icon'} />
        {buttonLabel}
      </FlexRow>
    </StyledButton>
  );
};
